/**
 * /frontend/src/features/analytics/hooks/useAnomalyAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getActiveAnomalies, getAnomalyHistory } from '../api/anomalyAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads anomaly analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useAnomalyAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, startDate, endDate, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [active, history] = await Promise.all([
      getActiveAnomalies(request, storeToken, storeUuid),
      getAnomalyHistory(request, storeToken, storeUuid, startDate, endDate),
    ]);
    return { active, history };
  }, [endDate, request, startDate, storeToken, storeUuid]);

  const resource = useAnalyticsResource(enabled, fetcher, 'useAnomalyAnalytics', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default useAnomalyAnalytics;
